import * as React from 'react';
import { cn } from '../../lib/utils';

const Input = React.forwardRef(
  (
    {
      className,
      type = 'text',
      selectAllOnFocus = false,
      onFocus,
      onMouseDown,
      ...props
    },
    ref,
  ) => {
    const handleFocus = React.useCallback(
      (event) => {
        if (selectAllOnFocus && event?.target?.select) {
          event.target.select();
        }
        if (onFocus) {
          onFocus(event);
        }
      },
      [selectAllOnFocus, onFocus],
    );

    const handleMouseDown = React.useCallback(
      (event) => {
        if (selectAllOnFocus) {
          const target = event?.target;
          const activeElement =
            typeof document !== 'undefined' ? document.activeElement : null;

          if (
            target &&
            typeof target.focus === 'function' &&
            typeof target.select === 'function' &&
            target !== activeElement
          ) {
            event.preventDefault();
            target.focus();
            return;
          }
        }

        if (onMouseDown) {
          onMouseDown(event);
        }
      },
      [selectAllOnFocus, onMouseDown],
    );

    return (
      <input
        type={type}
        ref={ref}
        className={cn(
          'form-input tw-flex tw-h-11 tw-w-full tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-50 tw-px-4 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-inner tw-transition-all placeholder:tw-text-slate-400 hover:tw-border-indigo-300 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-indigo-400 focus-visible:tw-border-indigo-500 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 dark:tw-border-slate-700 dark:tw-bg-slate-800 dark:tw-text-slate-100 dark:placeholder:tw-text-slate-500 dark:hover:tw-border-indigo-400/40 dark:focus-visible:tw-ring-indigo-300/60',
          className,
        )}
        onFocus={handleFocus}
        onMouseDown={handleMouseDown}
        {...props}
      />
    );
  },
);

Input.displayName = 'Input';

export { Input };
